import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Button,
  Checkbox,
  Stack,
  TextField
} from '@mui/material';
import { Check } from '@mui/icons-material';
import { getAnalytics, logEvent } from 'firebase/analytics';
import { useTranslation } from 'react-i18next';
import { ProgressContext } from '../context/Progress';
import { ApiContext } from '../context/Api';

const USER_ANSWERS = 'userAnswers';

function Done({ data }) {
  const { apiService } = useContext(ApiContext);
  const [shareAnswer, setShareAnswer] = useState(false);
  var userEmail = '';

  const { t } = useTranslation();
  const navigate = useNavigate();
  const progress = useContext(ProgressContext);

  async function doneAction() {
    if (shareAnswer) {
      try {
        await _sendEmail();
      } catch (error) {
        console.log(`Error sending email: ${error}`);
      }
    }
    await progress.completeLesson(data.slug);
    logEvent(getAnalytics(), 'complete_lesson', {
      course: data.course.slug,
      lesson: data.slug
    });
    navigate('../../');
  }

  async function _sendEmail() {
    const userAnswers = JSON.parse(localStorage.getItem(USER_ANSWERS));

    if (!data.blocks) {
      return;
    }

    if (!userAnswers) {
      return;
    }

    const lessonId = data.id;
    const lessonAnswers = userAnswers.filter(e => e.lessonId === lessonId);

    if (!lessonAnswers) {
      return;
    }

    const questionAnswers = [];
    const lessonTitle = data.name;
    const questionBlocs = data.blocks.filter(e => e.type === 'questions');
    questionBlocs.forEach(questionBloc => {
      const question = questionBloc.content;

      const answer = lessonAnswers.find(e => e.lessonblock === questionBloc.id);

      questionAnswers.push({
        question,
        answer: answer ? answer.answer : ''
      });
    });

    let answerString = '';

    for (let i = 0; i < questionAnswers.length; i++) {
      const questionAnswer = questionAnswers[i];
      answerString += `
      <ol start="${i + 1}">
      <li>${questionAnswer.question} <br><br>A: ${questionAnswer.answer}</li>
      </ol>`;
    }

    const body = `${lessonTitle}<br><br> <h3>Questions</h3>${answerString}`;

    apiService
      .sendEmail(userEmail, 'New answers for lesson ' + lessonTitle, body)
      .then(() => {
        // Handle success.
        // setShowAskHelpToast(true);
      })
      .catch(error => {
        console.log('An error occurred:', error.response);
      });
  }

  return (
    <div>
      <Stack
        className="share-answers-container"
        direction="row"
        spacing={0}
      >
        <Checkbox
          checked={shareAnswer}
          onChange={e => {
            setShareAnswer(e.target.checked);
            if (e.target.checked) {
              setTimeout(() => {
                document.getElementById('recipientEmail').focus();
              }, 100);
            }
          }}
          sx={{
            background: 'var(--mui-palette-FilledInput-bg)',
            borderRadius: 0,
            border: '1px solid rgba(var(--mui-palette-common-onBackgroundChannel) / 0.23)'
          }}
        />

        <TextField
          label={t('lesson.shareAnswer')}
          placeholder={t('lesson.recipientEmail')}
          type="text"
          id="recipientEmail"
          variant="outlined"
          disabled={!shareAnswer}
          onChange={e => (userEmail = e.target.value)}
          sx={{
            flexGrow: 1,
            '.MuiInputBase-root': {
              borderRadius: 0,
            }
          }}
        />
      </Stack>

      <div className="done-button">
        <Button
          onClick={doneAction}
          variant="contained"
          size="large"
          startIcon={<Check />}
        >
          {t('lesson.done')}
        </Button>
      </div>
    </div>
  );
}
export default Done;
